
export function getRequestDeletionConfirmationMessage(studyRequests) {
    for (const studyRequest of studyRequests) {
        const hasIncidents = studyRequest.incidents > 0

        // attachments can be either an integer or an array depending on the component that makes the call
        const hasAttachments = studyRequest.attachments && (
            (studyRequest.attachments.length > 0) || (studyRequest.attachments > 0))

        if (hasIncidents && hasAttachments) {
            return 'studyRequest.modals.requestDeleteConfirmationWithAttachmentsAndIncidents'
        } else if (hasIncidents) {
            return 'studyRequest.modals.requestDeleteConfirmationWithIncidents'
        } else if (hasAttachments) {
            return 'studyRequest.modals.requestDeleteConfirmationWithAttachments'
        }
    }
    return 'component.modalConfirmation.content'
}

export function getCaseDeletionConfirmationMessage(caseStudy) {
    const hasIncidents = caseStudy.incidentsCount > 0
    const hasAttachments = caseStudy.attachmentsCount > 0

    if (hasIncidents && hasAttachments) {
        return 'registry.modal.caseDeleteConfirmationWithAttachmentsAndIncidents'
    } else if (hasIncidents) {
        return 'registry.modal.caseDeleteConfirmationWithIncidents'
    } else if (hasAttachments) {
        return 'registry.modal.caseDeleteConfirmationWithAttachments'
    }
    return ''
}

export function getSampleDeletionConfirmationMessage(samples) {
    for (const sample of samples) {
        const hasIncidents = sample.incidentsCount > 0
        const hasAttachments = sample.attachmentsCount > 0

        if (hasIncidents && hasAttachments) {
            return 'registry.modal.sampleDeleteConfirmationWithAttachmentsAndIncidents'
        } else if (hasIncidents) {
            return 'registry.modal.sampleDeleteConfirmationWithIncidents'
        } else if (hasAttachments) {
            return 'registry.modal.sampleDeleteConfirmationWithAttachments'
        }
    }
    return ''
}

export function getPortionDeletionConfirmationMessage(portions) {
    for (const portion of portions) {
        const hasIncidents = portion.incidentsCount > 0
        const hasAttachments = portion.attachmentsCount > 0

        if (hasIncidents && hasAttachments) {
            return 'grossing.modal.portionDeleteConfirmationWithAttachmentsAndIncidents'
        } else if (hasIncidents) {
            return 'grossing.modal.portionDeleteConfirmationWithIncidents'
        } else if (hasAttachments) {
            return 'grossing.modal.portionDeleteConfirmationWithAttachments'
        }
    }
    return ''
}
